import { formatDate } from "@/utils/datetime";

/**
 * Data de nascimento em dd/mm/aaaa.
 * Mantido como reexport para não quebrar os pontos de uso — a implementação
 * única de formatação vive em utils/datetime.js.
 */
export function formatBirthDate(dateString) {
  return formatDate(dateString, { fallback: "Data inválida" });
}
